// Include JR Starter core files


// General
//@codekit-prepend "general/helpers.js"
//@codekit-prepend "general/modernizr.js"
//@codekit-prepend "general/picturefill.js"
//@codekit-prepend "general/jquery.unevent.js"

//
// Foundation
//@codekit-prepend "jr-foundation-min.js"


// JR Plugins
//@codekit-append "jr-plugins/load-images.js"
//@codekit-append "jr-plugins/scroll-animate.js"
//@codekit-append "jr-plugins/banner.js"
//@codekit-append "jr-plugins/fix-this.js"


// Templates
// @codekit-append "templates/header.js"


// Classes
// @codekit-append "classes/menu.js"



(function ( $ ) {
	
	"use strict";
	
	$(document).ready(onReady);
	$(window).on('load', onLoad);
	
	// Callback function for when the page is ready
	function onReady() {
		
		// Initialise Foundation
		$(document).foundation();

		// Slick
		$('.jr-carousel [data-slick]').slick();

		// DZS Parallax
		dzsprx_init('.dzsparallaxer', { 
			direction: "reverse", 
			mode_scroll:"normal",
			animation_duration: 5,
			is_fullscreen: true
		} );

		// MMenu
		var smallMenu = $('#jr-small-menu');
		if (
			$.isFunction($.fn.mmenu) &&
			smallMenu.length === 1
		) {

			var type = smallMenu.data('type');

			var options = {
		        extensions: [
		        "fx-menu-slide",
		        "pagedim-black"
		        ]
		    };

		    var configurations = {

		        offCanvas: {
		            pageSelector: "#page"
		        },

		        classNames: {
		            fixedElements: {
		               fixed: "jr-small-top-menu"
		            }
		        }
		    }

		    if (type === 'popup') {

		    	options.extensions.push("popup");
		    	var index = options.extensions.indexOf('fx-menu-slide');
		    	if (index > -1) {
				    options.extensions.splice(index, 1);
				}

		    }

			$("#jr-small-menu").mmenu(options, configurations);

		}

	}
	
	function onLoad() {
		



		
	}
	
}( jQuery ));
